<template>
  <div>
    <div class="public-table-but__left">
      <div class="item">
        <!-- <em>筛选：</em> -->
        <div class="item-wp">
          <template v-if="searchShow">
            <div class="item-son">
              <el-input
                  v-model="listParams.searchKey"
                  placeholder="搜索关键词"
                  clearable
                  @keyup.enter.native="SearchChannelList"
              ></el-input>
            </div>
            <div class="item-son">
              <el-select
                  v-model="listParams.status"
                  clearable
                  placeholder="请选择状态"
                  style="width: 120px"
              >
                <el-option label="正常" value="1"></el-option>
                <el-option label="禁用" value="0"></el-option>
              </el-select>
            </div>
            <div class="item-son">
              <el-select
                  v-model="listParams.channelType"
                  placeholder="请选择渠道"
                  clearable
                  filterable
                  style="width: 100%"
              >
                <el-option
                    v-for="(item, index) in channelData"
                    :key="index"
                    :label="item.name"
                    :value="item.channelType"
                ></el-option>
              </el-select>
            </div>
            <div class="item-son">
              <el-button type="primary" @click="SearchChannelList"
              >查询 <i class="el-icon-search"></i>
              </el-button>
            </div>
          </template>
          <div class="item-son" v-if="addShow">
            <el-button type="primary" @click="handleClick('add')"
            >新增 <img src="@assets/images/add-icon.png" alt=""/>
            </el-button>
          </div>
        </div>
      </div>
    </div>

    <div class="public-table-data">
      <el-table
          ref="multipleTable"
          size="medium"
          :data="tableData"
          border
          style="width: 100%"
          row-key="menuId"
          v-loading="loading"
      >
        <el-table-column
            align="center"
            fixed
            label="序号"
            type="index"
            width="100"
        >
          <template slot-scope="scope">
                <span>{{
                    (pages.pageNo - 1) * pages.pageSize + scope.$index + 1
                  }}</span>
          </template>
        </el-table-column>
        <el-table-column
            prop="channelTypeName"
            label="渠道"
            width="120"
            align="center"
        >
        </el-table-column>
        <el-table-column prop="account" label="账号" width="120" align="center">
        </el-table-column>
        <el-table-column prop="name" label="名称" width="120" align="center">
        </el-table-column>
        <el-table-column prop="code" label="标识" width="120" align="center">
        </el-table-column>
        <el-table-column
            prop="putWayName"
            label="投放方式"
            width="200"
            align="center"
        >
        </el-table-column>
        <el-table-column
            prop="channelMchName"
            label="渠道商"
            width="120"
            align="center"
        >
        </el-table-column>
        <el-table-column
            prop="companyName"
            label="主体"
            width="120"
            align="center"
        >
        </el-table-column>
        <el-table-column
            prop="domainBizAddress"
            label="业务域名"
            width="120"
            align="center"
        >
        </el-table-column>

        <el-table-column prop="descr" label="说明" width="120" align="center">
        </el-table-column>

        <el-table-column prop="ctime" label="时间" width="120" align="center">
        </el-table-column>

        <el-table-column v-if=" userInfo && userInfo.operateStatus==1" prop="code" label="状态" width="100" align="center">
          <template slot-scope="scope">
            <template v-if="numType">
              <el-switch
                  :disabled="statusShow"
                  v-model="scope.row.status"
                  :active-value="1"
                  :inactive-value="0"
                  @change="changeSwitch(scope.row)"
              >
              </el-switch>
            </template>
            <template v-else>
              <el-switch
                  :disabled="statusShow"
                  :value="scope.row.status"
                  :active-value="1"
                  :inactive-value="0"
                  @change="operationShowTime"
              >
              </el-switch>
            </template>

          </template>
        </el-table-column>

        <el-table-column label="操作" v-if="userInfo && userInfo.operateStatus==1" align="center" fixed="right" min-width="260">
          <template slot-scope="scope">
              <el-button
                  size="mini"
                  @click="handleClick('edit', scope.row)"
                  type="warning"
                  plain
                  v-if="editShow"
              >编辑
              </el-button
              >
              <el-button
                  v-if="cfg"
                  size="mini"
                  @click="handleClick('configuration', scope.row)"
                  type="success"
                  plain
              >配置
              </el-button
              >
              <el-button
                  size="mini"
                  @click="handleDelete(scope.row)"
                  type="primary"
                  plain
                  v-if="numType && deleteShow"
              >删除
              </el-button
              >
              <el-button
                  v-if="!numType && deleteShow"
                  size="mini"
                  @click="operationShowTime"
                  type="primary"
                  plain
              >删除
              </el-button
              >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="public-pagination">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pages.pageNo"
            :page-sizes="[PAGE_SIZE, 50, 100, 200, 400]"
            :page-size="pages.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
        >
        </el-pagination>
      </div>
    </div>

    <!-- 编辑弹框 -->
    <el-dialog
        title="新增/编辑渠道账号"
        :visible.sync="dialogVisible"
        width="460px"
        :close-on-click-modal="false"
        class="public-dialog"
    >
      <div class="public-dialog-form">
        <el-form
            ref="ruleForm"
            :rules="rules"
            :model="params"
            label-width="80px"
        >
          <el-form-item prop="channelType" label="渠道">
            <el-select
                v-model="params.channelType"
                clearable
                filterable
                placeholder="请选择渠道"
                style="width: 100%"
            >
              <el-option
                  v-for="(item, index) in channelData"
                  :key="index"
                  :label="item.name"
                  :value="item.channelType"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item prop="channelMchId" label="渠道商">
            <el-select
                v-model="params.channelMchId"
                clearable
                filterable
                placeholder="请选择渠道商"
                style="width: 100%"
            >
              <el-option
                  v-for="(item, index) in channelTradeData"
                  :key="index"
                  :label="item.name"
                  :value="item.channelMchId"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item prop="putWay" label="投放方式">
            <el-select
                v-model="params.putWay"
                clearable
                filterable
                placeholder="请选择投放方式"
                style="width: 100%"
            >
              <el-option
                  v-for="(item, index) in putInData"
                  :key="index"
                  :label="item.enumName"
                  :value="item.enumVal"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="账号">
            <el-input
                placeholder="请填渠道账号"
                v-model="params.account"
            ></el-input>
          </el-form-item>

          <el-form-item label="名称" prop="name">
            <el-input
                placeholder="请填名称"
                v-model="params.name"
            ></el-input>
          </el-form-item>

          <el-form-item label="标识" prop="code">
            <el-input
                placeholder="请填渠道标识"
                v-model="params.code"
                :disabled="clickType=='edit'"
            ></el-input>
          </el-form-item>

          <el-form-item prop="companyId" label="主体">
            <el-select
                v-model="params.companyId"
                clearable
                filterable
                placeholder="请选择签约主体"
                style="width: 100%"
                @change="changeMain"
                :disabled="clickType=='edit'"
            >
              <el-option
                  v-for="(item, index) in companyData"
                  :key="index"
                  :label="item.fullName"
                  :value="item.companyId"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item prop="domainBizId" label="业务域名">
            <el-select
                v-model="params.domainBizId"
                clearable
                filterable
                placeholder="请选择业务域名"
                style="width: 100%"
                :disabled="isDisabled"
            >
              <el-option
                  v-for="(item, index) in businessData"
                  :key="index.domainBizId"
                  :label="item.domainBizAddress"
                  :value="item.domainBizId"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="说明">
            <el-input
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 4 }"
                placeholder="请填写说明"
                v-model="params.descr"
            >
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="public-dialog-footer">
        <el-button size="medium" @click="dialogVisible = false"
        >取 消</el-button
        >
        <el-button size="medium" type="primary" @click="handleEdit"
                   v-if="numType"
        >提 交</el-button
        >
        <el-button size="medium" type="primary" @click="operationShowTime"
                   v-else
        >提 交</el-button
        >
      </span>
    </el-dialog>

    <!-- 回调配置弹框 -->
    <el-dialog
        title="回调配置"
        :visible.sync="dialogCallBack"
        width="520px"
        :close-on-click-modal="false"
        top="40px"
        class="public-dialog"
    >
      <div class="public-dialog-form">
        <el-form
            ref="ruleCallBackForm"
            :rules="callRules"
            :model="callParams"
            label-width="100px"
        >
          <div style="display: flex;justify-content: flex-end" >
            <el-button @click="handleClick('configuration',ChannelInformation)" style="border: none;" icon="el-icon-refresh" circle></el-button>
          </div>
          <el-form-item prop="apiStatus" label="回调状态">
            <el-switch
                v-model="callParams.apiStatus"
                :active-value="1"
                :inactive-value="0"

            ></el-switch>
          </el-form-item>
          <el-form-item prop="frontendCallbackStatus" label="前端回调状态">
            <el-switch
                v-model="callParams.frontendCallbackStatus"
                :active-value="1"
                :inactive-value="0"

            ></el-switch>
          </el-form-item>
          <el-form-item label="上报像素" prop="pixelJs">
            <el-input
                placeholder="请填写上报像素"
                v-model="callParams.pixelJs"
            ></el-input>
          </el-form-item>
          <el-form-item label="回调地址" prop="apiUrl">
            <el-input
                placeholder="请填写回调地址"
                v-model="callParams.apiUrl"
            ></el-input>
          </el-form-item>

          <el-form-item label="回调参数1" prop="apiUrl">
            <el-input
                placeholder="请填写回调参数1"
                v-model="callParams.apiToken"
            ></el-input>
          </el-form-item>
          <el-form-item label="回调参数2" prop="apiUrl">
            <el-input
                placeholder="请填写回调参数2"
                v-model="callParams.apiToken1"
            ></el-input>
          </el-form-item>
          <div class="block" style="margin-bottom: 20px" v-if="ChannelInformation.channelType=='wb'">
            <span class="demonstration">过期时间：</span>
            <el-date-picker
                v-model="callParams.expireTime"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择时间">
            </el-date-picker>
            <el-button style="margin-left: 10px" plain type="primary" @click="RefreshAuthorization">
              刷新授权
            </el-button>
          </div>
          <el-form-item label="回调事件">
            <div class="item-son"></div>
            <el-table
                size="mini"
                :data="tableCallData"
                border
                style="width: 100%"
                row-key="menuId"
                v-loading="loading"
            >
              <el-table-column
                  type="index"
                  label="序号"
                  width="60"
                  align="center"
              >
              </el-table-column>
              <el-table-column prop="name" label="名称" align="center">
              </el-table-column>
              <el-table-column prop="code" label="标识" align="center">
              </el-table-column>
              <el-table-column prop="val" label="值" align="center">
                <template slot-scope="scope">
                  <el-input
                      type="text"
                      v-model="scope.row.val"
                      placeholder="请输值"
                      size="mini"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="val" label="目标" align="center">
                <template slot-scope="scope">
                  <el-switch
                      v-model="scope.row.target"
                      :active-value="1"
                      :inactive-value="0"
                  >
                  </el-switch>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>

          <el-form-item label="统计代码"></el-form-item>

          <el-form-item label="Header" prop="headerJs">
            <el-input
                type="textarea"
                :autosize="{ minRows: 4, maxRows: 4 }"
                placeholder="请填写Header代码"
                v-model="callParams.headerJs"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="Body" prop="bodyJs">
            <el-input
                type="textarea"
                :autosize="{ minRows: 4, maxRows: 4 }"
                placeholder="请填写Body代码"
                v-model="callParams.bodyJs"

            >
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="public-dialog-footer">
        <el-button size="medium" @click="dialogCallBack = false"
        >取 消</el-button
        >
        <el-button size="medium" type="primary" @click="handleCallBackEdit"
                   v-if="numType"
        >提 交</el-button
        >
        <el-button size="medium" type="primary" @click="operationShowTime"
        v-else
        >提 交</el-button
        >
      </span>
    </el-dialog>
    <operation-confirmation  @closeOperation="publicMethios" :operationVisible="operationVisible"></operation-confirmation>
  </div>
</template>
<script>
import {PAGE_SIZE, FILE_ROOT, JOB_STATUS} from "@config";
import OperationConfirmation from "../../components/OperationConfirmation";

export default {
  components: {OperationConfirmation},
  data() {
    return {

      channelData: [],
      channelTradeData: [],
      putInData: [],
      businessData: [],
      companyData: [],
      tableData: [],
      tableCallData: [],
      listParams: {},
      params: {},
      clickType: "",
      clickCallType: "",
      callParams: {
        apiStatus: 1,
        val: "",
        expireTime: ''

      },
      dialogVisible: false,
      dialogCallBack: false,
      isDisabled: true,
      total: 0,
      value1: '',
      PAGE_SIZE,
      pages: {
        pageNo: 1,
        pageSize: PAGE_SIZE,
      },
      loading: false,
      rules: {
        channelType: [
          {required: true, message: "请选择渠道", trigger: "change"},
        ],
        channelMchId: [
          {required: true, message: "请选择渠道商", trigger: "change"},
        ],
        putWay: [
          {required: true, message: "请选择投放方式", trigger: "change"},
        ],
        // account: [
        //   { required: true, message: "请填写渠道商账号", trigger: "change" },
        // ],
        code: [
          {required: true, message: "请填写渠道标识", trigger: "change"},
        ],
        companyId: [
          {required: true, message: "请选择签约主体", trigger: "change"},
        ],
        domainBizId: [
          {required: true, message: "请选择业务域名", trigger: "change"},
        ],
        // descr: [{ required: true, message: "请填写说明", trigger: "change" }],
        name: [{required: true, message: "请填写名称", trigger: "change"}]
      },
      callRules: {
        // apiUrl: [
        //   { required: true, message: "请填写回调地址", trigger: "change" },
        // ],
        // apiToken: [
        //   { required: true, message: "请填写渠道Token", trigger: "change" },
        // ],
        // headerJs: [
        //   { required: true, message: "请填写Header代码", trigger: "change" },
        // ],
        // bodyJs: [
        //   { required: true, message: "请填写Body代码", trigger: "change" },
        // ],
      },
      ChannelInformation:{},
      operationVisible:false,
      numType:false,

      addShow: false,
      deleteShow: false,
      editShow: false,
      statusShow: true,
      searchShow: false,
      cfg:false
    };
  },
  computed:{
    userInfo(){
      return this.$store.state.userInfo
    }
  },
  created() {
    if(window.sessionStorage.getItem('operationKey')){
      this.numType = true
    }
    this.queryTableData();
    this.channelList();
    this.channelTrade();
    this.putInList();
    this.companyList();
    this.getPermissionButtonList()
    // this.businessDomainName();
  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible == false) {
        this.$refs["ruleForm"].resetFields();
        this.params = {};
      }
    },
  },
  methods: {
    getPermissionButtonList() {
      let PermissionButtonList = window.sessionStorage.getItem('TaotanPermissionButton')
      let arr = JSON.parse(PermissionButtonList)
      if (arr.length) {
        arr.map(item => {
          if (item.code == 'channel:account:cfg') {
            this.cfg = true
          }
          if (item.code == 'channel:account:query') {
            this.searchShow = true
          }
          if (item.code == 'channel:account:add') {
            this.addShow = true
          }
          if (item.code == "channel:account:delete") {
            this.deleteShow = true
          }
          if (item.code == "channel:account:edit") {
            this.editShow = true
          }
          if(item.code == "channel:account:status"){
            this.statusShow = false
          }
        })
      }
    },
    //清楚缓存数据，重启密码验证
    clearStore(){
      window.sessionStorage.removeItem('operationKey')
      this.numType = false
    },
    //关闭
    publicMethios(e){
      this.operationVisible = false
      if(e=='open'){
        this.numType = true
        setTimeout(()=>{
          window.sessionStorage.removeItem('operationKey')
          this.numType = false
        },300000)
      }
    },
    //调起字组件的操作密码框
    operationShowTime(e){
      this.operationVisible = true
    },
    /**
     *  渠道列表
     */
    async channelList() {
      const {data: resData} = await this.$get(
          "channel/type/list",
          {
            params: {
              status: 1,
              paging: false,
            },
          },
          {
            headers: {
              isLoading: true,
            },
          }
      );
      if (resData.result != 200) return;
      this.channelData = resData.data;
    },

    /**
     * 获取渠道商
     */
    async channelTrade() {
      this.loading = true;

      const {data: resData} = await this.$get("channel/mch/list?paging=false");
      this.loading = false;
      if (resData.result != 200) return;
      this.channelTradeData = resData.data;
    },

    /**
     * 获取投放方式
     */
    async putInList() {
      this.loading = true;

      const {data: resData} = await this.$get(`enums/list/PUT_WAY`);
      this.loading = false;
      if (resData.result != 200) return;
      this.putInData = resData.data;
    },
    /**
     * 主体列表（企业列表）
     */
    async companyList() {
      this.loading = true;
      const {data: resData} = await this.$get("company/list?paging=false");
      this.loading = false;
      if (resData.result != 200) return;
      this.companyData = resData.data;
    },
    /**
     * 获取业务域名
     */
    // async businessDomainName() {
    //   this.loading = true;

    //   const { data: resData } = await this.$get("domain/biz/list");
    //   this.loading = false;
    //   if (resData.result != 200) return;
    //   this.businessData = resData.data;
    // },

    SearchChannelList(){
      this.pages.pageNo = 1
      this.queryTableData()
    },

    /**
     * 获取主列表
     */
    async queryTableData() {
      this.loading = true;

      const {data: resData} = await this.$get("channel/account/list", {
        params: {
          ...this.listParams,
          ...this.pages,
        },
      });
      this.loading = false;
      if (resData.result != 200) return;
      this.tableData = resData.data;
      this.total = resData.page.count;
    },

    /* 切换主体下的业务域名 */
    changeMain() {
      if (this.params.companyId != undefined && this.params.companyId != '') {
        this.isDisabled = false;
      } else {
        this.isDisabled = true;
      }

      // 获取 相关联的业务域名
      this.$get("domain/biz/list", {
        params: {
          status: 1,
          paging: false,
          // companyId:this.params.companyId
        },
      }).then(res => {
        if (res.data.data != undefined) {
          this.businessData = res.data.data
        } else {
          this.businessData = []
          this.domainBizId = ''
        }
      });
    },
    /**
     * 修改渠道账号状态
     */
    async changeSwitch(b) {
      const {data: resData} = await this.$put(
          `channel/account/info/status/${b.channelAccountId}`
      );
      this.loading = false;
      if (resData.result != 200) return;
      this.$message.success(resData.message);
      this.clearStore()
    },

    async RefreshAuthorization(){
      let localHref = window.location.href.split('/')
      let jumpLink =localHref[0]+'//'+localHref[2]+'/'+'taotan_admin_api'+"/weibo/redirect?appid="+this.callParams.apiToken
      window.open(jumpLink)
    },

    /**
     * 表格按钮点击
     */
    async handleClick(type, row = {}) {
      this.clickType = type;
      // if (type == "edit" || type == "add") this.dialogVisible = true;

      if (type == "edit") {
        //编辑
        this.params = JSON.parse(JSON.stringify(row));
        this.changeMain()

        setTimeout(() => {
          this.dialogVisible = true;
        }, 500);

      }
      if (type == "add") {
        this.dialogVisible = true;
        this.params = {};
      }
      if (type == "configuration") {
        this.ChannelInformation = row
        this.dialogCallBack = true;
        this.callParams.channelAccountId = row.channelAccountId;
        const {data: resData} = await this.$get(
            `channel/api/info/${row.channelAccountId}`,
            {
              headers: {
                isLoading: true,
              },
            }
        );

        if (resData.result != 200) return;
        this.callParams = resData.data;

        this.tableCallData = resData.data.eventParams;
      }
    },

    /**
     * 编辑/增加
     */
    handleEdit() {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return;
        this.$confirm("确认保存数据, 是否继续?", "提示", {
          type: "info",
        }).then(async () => {
          if (this.clickType == "add" || this.clickType == "addNext") {
            const {data: resData} = await this.$post(
                "channel/account/info",
                this.params,
                {
                  headers: {
                    isLoading: true,
                  },
                }
            );

            if (resData.result != 200) return;

            this.queryTableData();

            this.dialogVisible = false;

            this.$message.success("添加成功!");
            this.params = {};
          } else {
            const {data: resData} = await this.$put(
                "channel/account/info",
                this.params,
                {
                  headers: {
                    isLoading: true,
                  },
                }
            );

            if (resData.result != 200) return;

            this.queryTableData();

            this.dialogVisible = false;

            this.$message.success("修改成功!");
          }
        });
      });
      this.clearStore()
    },
    /**
     * 回调配置：编辑/增加
     */
    handleCallBackEdit() {
      // this.callParams.expireTime = this.value1
      this.$refs.ruleCallBackForm.validate((valid) => {
        if (!valid) return;
        this.$confirm("确认保存数据, 是否继续?", "提示", {
          type: "info",
        }).then(async () => {
          if (this.clickType == "configuration") {
            this.callParams.eventParams = this.tableCallData.map((item) => {
              return {
                code: item.code,
                val: item.val,
                target: item.target
              };
            });
            const {data: resData} = await this.$post(
                "channel/api/info",
                this.callParams,
                {
                  headers: {
                    isLoading: true,
                  },
                }
            );

            if (resData.result != 200) return;

            this.queryTableData();

            this.dialogCallBack = false;

            this.$message.success("添加成功!");
            this.callParams = {};
          } else {
            const {data: resData} = await this.$post(
                "channel/api/info",
                this.callParams,
                {
                  headers: {
                    isLoading: true,
                  },
                }
            );

            if (resData.result != 200) return;

            this.queryTableData();

            this.dialogCallBack = false;

            this.$message.success("修改成功!");
          }
        });
      });
      this.clearStore()
    },

    /**
     * 删除
     */
    handleDelete(row) {
      this.$confirm("此操作将永久删除数据, 是否继续?", "提示", {
        type: "warning",
      }).then(async () => {
        const {data: resData} = await this.$delete(
            `channel/account/info/${row.channelAccountId}`,
            {
              headers: {
                isLoading: true,
              },
            }
        );
        if (resData.result != 200) return;
        this.$message.success("删除成功!");
        this.queryTableData();
      });
      this.clearStore()
    },

    /**
     *  分页长度改变
     */
    handleSizeChange(val) {
      this.pages.pageNo = 1;
      this.pages.pageSize = val;

      this.queryTableData();
    },

    /**
     *  下一页
     */
    handleCurrentChange(val) {
      this.pages.pageNo = val;

      this.queryTableData();
    },
  },
};
</script>